<template>
  <div class="arvore-produtos-component">
    <v-layout class="list-container">
      <v-flex v-for="level in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="level">
        <div v-if="selectedPerLevel[level] !== undefined" class="level-text">
          <v-checkbox
            v-model="levelSelector[level].value"
            :indeterminate="levelSelector[level].indeterminate"
            class="pt-0 mb-3"
            :label="`Nível ${level + 1} (${selectedPerLevel[level].children.length} itens)`"
            hide-details
            @change="toggleAllFromLevel(level)"
          />
        </div>
        <div v-if="selectedPerLevel[level] !== undefined" class="list-column">
          <dynamic-scroller
            v-if="selectedPerLevel[level].children"
            v-slot="{ item, index, active }"
            class="vue-recycle-scroller scroller ready direction-vertical"
            page-mode
            :items="selectedPerLevel[level].children"
            :min-item-size="56"
          >
            <div class="item-list">
              <dynamic-scroller-item :item="item" :active="active" :data-index="index" watchData>
                <category-tree-item
                  v-if="forceUpdateItems"
                  :item="item"
                  selection-mode
                  :on-path="isItemOnPath(selectedPerLevel[level + 1], item)"
                  @selected-item="selectedItem"
                  @picked-item="pickItem"
                />
              </dynamic-scroller-item>
            </div>
          </dynamic-scroller>
          <!-- </div> -->
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  components: {
    DynamicScroller,
    DynamicScrollerItem,
    CategoryTreeItem: () => import('@/components/select-categories-modal/CategoryTreeItem.vue'),
  },
  props: {
    pickedItems: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedPerLevel: [],
    forceUpdateCounter: 0,
    forceUpdateItems: true,
    localPickedItems: [],
    levelSelector: [],
  }),
  computed: {
    ...mapState({
      stateCategoriesTree: (state) => state.produtos.categoriesTree,
    }),
  },
  watch: {
    pickedItems: {
      handler() {
        this.localPickedItems = this.pickedItems
        this.updatePickedItemsOnLevels()
      },
      deep: true,
    },
  },
  async mounted() {
    this.localPickedItems = this.pickedItems
    await this.getData()
    this.updatePickedItemsOnLevels()
  },
  methods: {
    updatePickedItemsOnLevels() {
      const pickedIds = this.pickedItems.map((item) => item.id)
      this.selectedPerLevel.forEach((level) => {
        level.children.forEach((child) => {
          child.picked = pickedIds.includes(child.id)
        })
      })
      this.forceUpdateItems = false
      this.$nextTick(() => {
        this.forceUpdateItems = true
      })
    },
    selectedItem(item) {
      if (item.children && item.children.length) {
        this.selectedPerLevel = this.selectedPerLevel.slice(0, item.level).concat(item)
        this.levelSelector = this.levelSelector.slice(0, item.level).concat(this.getLevelSelectorObject(item.level))
        this.updatePickedItemsOnLevels()
        this.$nextTick(() => {
          let container = document.querySelector('.list-container')
          container.scrollLeft = container.scrollWidth
        })
      } else {
        this.selectedPerLevel = this.selectedPerLevel.slice(0, item.level)
        this.levelSelector = this.levelSelector.slice(0, item.level)
      }
    },
    pickItem(item) {
      this.forceUpdateItems = false
      this.updatePickedItems(item)
      this.selectedItem(item)
      this.updateLevelSelector(item)
      // TODO: think about how to show picked in the parent
      // this.updateParentPickedStatus(item)
      this.$nextTick(() => {
        this.forceUpdateItems = true
      })
    },
    updateLevelSelector(item) {
      this.levelSelector[item.level - 1] = this.getLevelSelectorObject(item.level - 1)
    },
    updatePickedItems(item) {
      if (item.picked) {
        this.localPickedItems.push({
          name: item.name,
          id: item.id,
        })
      } else {
        this.localPickedItems = this.localPickedItems.filter((pickedItem) => pickedItem.id !== item.id)
      }
      this.$emit('update:picked-items', this.localPickedItems)
    },
    updateParentPickedStatus(item) {
      if (!item.level) return

      for (let parentLevel = item.level - 1; parentLevel >= 1; parentLevel--) {
        const parentObject = this.selectedPerLevel[parentLevel]

        if (parentObject) {
          let indeterminateChildren = parentObject.children.filter((obj) => obj.indeterminate).length
          let pickedChildren = parentObject.children.filter((obj) => obj.picked).length

          let childrenLength = parentObject.children.length
          if (indeterminateChildren >= 1) {
            this.setCheckboxToIndeterminate(parentObject)
          } else if (pickedChildren === 0) {
            this.setCheckboxToFalse(parentObject)
          } else if (childrenLength === pickedChildren) {
            this.setCheckboxToTrue(parentObject)
          } else {
            this.setCheckboxToIndeterminate(parentObject)
          }
        }
      }
    },
    setCheckboxToFalse(object) {
      object.picked = false
      object.indeterminate = false
    },
    setCheckboxToIndeterminate(object) {
      object.picked = false
      object.indeterminate = true
    },
    setCheckboxToTrue(object) {
      object.picked = true
      object.indeterminate = false
    },
    isItemOnPath(selected, item) {
      if (!selected || !item) return false
      return Boolean(selected.name === item.name)
    },
    getData() {
      this.selectedPerLevel.push(this.stateCategoriesTree)
      this.levelSelector.push(this.getLevelSelectorObject(0))
    },
    getLevelSelectorObject(level) {
      const pickedIds = this.localPickedItems.map((item) => item.id)
      const items = this.selectedPerLevel[level].children
      const selectedItems = items.filter((child) => pickedIds.includes(child.id))
      return {
        value: selectedItems.length === items.length,
        indeterminate: selectedItems.length !== items.length && selectedItems.length > 0,
      }
    },
    toggleAllFromLevel(level) {
      if (!this.selectedPerLevel[level]?.children?.length) {
        return
      }
      if (this.levelSelector[level].value) {
        this.addAllFromLevel(level)
      } else {
        this.removeAllFromLevel(level)
      }
    },
    addAllFromLevel(level) {
      const pickedIds = this.pickedItems.map((item) => item.id)
      const newItemsToSelect = this.selectedPerLevel[level].children.reduce((acc, child) => {
        if (!pickedIds.includes(child.id)) {
          acc.push({
            name: child.name,
            id: child.id,
          })
        }
        return acc
      }, [])
      this.localPickedItems = this.localPickedItems.concat(newItemsToSelect)
      this.$emit('update:picked-items', this.localPickedItems)
    },
    removeAllFromLevel(level) {
      const levelIds = this.selectedPerLevel[level].children.map((item) => item.id)
      this.localPickedItems = this.localPickedItems.filter((pickedItem) => !levelIds.includes(pickedItem.id))
      this.$emit('update:picked-items', this.localPickedItems)
    },
  },
}
</script>
<style lang="scss" scoped>
.list-column {
  max-height: 500px;
  overflow: auto;
}
</style>
